<template>
  <div>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="!loading && errorMessage !== null">
      {{errorMessage}}
    </div>
    <div class="loading" v-if="!loading && errorMessage === null">
      <md-card v-for="context in locks" :key="context.context.id">
        <md-card-header>
          <div class="md-title">{{context.context.id}}</div>
        </md-card-header>

        <md-card-content>
            <md-card v-for="key in context.keys" :key="key.key" v-if="key.locks.length > 0" class="key-card md-with-hover">
              <md-card-header>
                <div class="md-title">{{key.key}}</div>
              </md-card-header>

              <md-card-content>
                <div v-for="lock in key.locks">
                  {{lock.usersName}} ({{lock.websocketId}}) - {{lock.createTimestamp}}
                </div>
              </md-card-content>
            </md-card>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
  export default {
    name: "active-view",
    data() {
      return {
        loading: true,
        errorMessage: null,
        lockSubscriptionId: null,
        locks: []
      }
    },
    created() {
      this.lockSubscriptionId = this.$store.api.subscribe("SOFTLOCKS", null, this.lockChangeHandler);
      this.getAllLocks();
    },
    beforeDestroy() {
      if (this.lockSubscriptionId) {
        this.$store.api.unsubscribe(this.lockSubscriptionId);
      }
      this.lockSubscriptionId = null;
    },
    methods: {
      getAllLocks() {
        this.loading = true;
        this.errorMessage = null;
        this.$store.api.rpcRequest('getAllLocks', {}, rawLocks => {
          this.locks = rawLocks;
          this.loading = false;
        }, errorMessage => {
          this.loading = false;
          this.errorMessage = errorMessage;
        });
      },
      lockChangeHandler(data) {
        var found = false;
        this.locks.forEach(context => {
          if (context.context.id === data.context.id) {
            Object.assign(context, data);
            found = true;
          }
        });
        if (!found) {
          this.locks.push(data);
        }
      }
    }
  }
</script>

<style scoped>
  .key-card {
    width: 400px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

  .md-card {
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/ActiveView.vue